import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { isLogin } from "../../context/auth/auth.provider";
import Loader from "../../component/Loader";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const loadingState = useSelector((state) => state.loader);
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (isLogin() && location.pathname === "/admin/add-user") {
      if (user.adminData.roles.name !== "superadmin") {
        navigate("/");
      }
    }
  }, [location.pathname]);

  return isLogin() ? (
    <Loader showLoader={loadingState.showLoader}> {children} </Loader>
  ) : (
    <Navigate to="/sign-in" />
  );
};

export default ProtectedRoute;
